import * as React from "react";

import { cn } from "@/lib/utils";

function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        `file:text-foreground placeholder:text-[#D9D9D9] selection:bg-primary selection:text-primary-foreground
        dark:bg-input/30 border-input flex p-3 h-[42px] md:p-2 md:h-[38px] landscape:p-2 landscape:h-[38px] w-full min-w-0 border bg-transparent px-[14px]
        text-[14px] outline-none
        file:inline-flex file:h-7 file:border-0 font-medium
        disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 
        aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive`,
        className
      )}
      {...props}
    />
  );
}

export { Input };
